import { useQuery } from '@tanstack/react-query'
import { Building2 } from 'lucide-react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/avatar/avatar'
import { Skeleton } from '@/components/skeleton/skeleton'

import { getCompanyQuery } from '@/lib/queries/business/v1/company/queries'
import { cn } from '@/lib/utils'

import { BulkUploadButton } from './bulk-upload-button'
import { CaseUsageIndicator } from './case-usage-indicator/case-usage-indicator'

export const NavBar = () => {
  const { data: dataCompany } = useQuery(getCompanyQuery)

  return (
    <div className={cn('flex items-center justify-between', 'h-nav-bar', 'border-b', 'pl-3 pr-10')}>
      <div className="mr-[60px] flex h-10 min-w-[230px] items-center justify-start space-x-2 rounded border px-4">
        {!dataCompany ? (
          <Skeleton className="h-6 w-6 rounded-full" />
        ) : (
          <Avatar className="h-6 w-6">
            <AvatarImage src={dataCompany?.logo_img} />
            {!!dataCompany && (
              <AvatarFallback className="bg-white">
                <Building2 size={21} />
              </AvatarFallback>
            )}
          </Avatar>
        )}
        {!dataCompany ? (
          <Skeleton className="h-5 w-3/4 rounded" />
        ) : (
          <span className="select-none font-medium">{dataCompany?.name}</span>
        )}
      </div>

      <div className="flex items-center space-x-5">
        <BulkUploadButton />
        <CaseUsageIndicator />
      </div>
    </div>
  )
}
